import { useNavigate } from "react-router-dom";

import welcomepic from "~/assets/images/wellcomepic.svg";
import Loader from "~/components/shared/Loader.jsx";
import Button from "~/components/ui/Button.jsx";
import ImageWithShimmer from "~/components/ui/ImageWithShimmer.jsx";

import { StatusUpdateIcon } from "../assets";
import StatusCard from "../components/status-card";
import { userActiveStatusoptions, userAdminStatusoptions } from "../constants";
import { useStatus } from "../hooks/use-status";
import styles from "./status.module.css";

const Status = () => {
  const { status: userStatus, userData } = useStatus();
  const navigate = useNavigate();

  const renderContent = () => {
    switch (userStatus) {
      case "notVerified":
        return (
          <div className={styles.welcomeCard}>
            <ImageWithShimmer src="/images/vandawelcomepic.png" alt="" />
            <div className={styles.welcomeCopy}>
              <p className={styles.welcomeTitle}>سلام، به وندا پرداخت خوش آمدید!</p>
              <p className={styles.welcomeText}>
                جهت دریافت درگاه پرداخت و دیگر خدمات ما وارد ناحیه کاربری شوید و اطلاعات خود را تکمیل کنید!
              </p>
            </div>
            <Button className={styles.shimmerButton} onClick={() => navigate("/user")}>
              تکمیل فرم احراز هویت
            </Button>
          </div>
        );
      case "verified":
        return (
          <div className={`${styles.verifiedWrap} no-scrollbar`}>
            <div className={styles.introCard}>
              <div>
                <ImageWithShimmer src={welcomepic} alt="" />
              </div>
              <p className={styles.introText}>
                وارد‌کردن‌اطلاعات‌ شخصی‌ و‌ بارگذاری‌ مدارک،‌ برای‌ پیمودن‌ مراحل‌ بعدی،‌الزامی‌است.
                تمام‌این‌اطلاعات‌ به‌صورت‌ محرمانه‌ نزد‌وندا‌پرداخت‌ نگه‌داشته‌ می‌شود‌ و‌ پرداخت‌‌ کننده،
                دسترسی‌به‌این‌اطلاعات‌‌ ندارد.
              </p>
            </div>
            <div className={styles.statusCard}>
              <div className={styles.statusHeader}>
                <img src={StatusUpdateIcon} alt="status-update-icon" className={styles.statusIcon} />
                <h1 className={styles.statusTitle}>آخرین وضعیت</h1>
              </div>
              <div className={styles.statusRow}>
                <StatusCard
                  label="وضعیت بررسی توسط ادمین"
                  value={userData?.approval_status}
                  options={userAdminStatusoptions}
                />
                <StatusCard label="وضعیت فعالی " value={userData?.active} options={userActiveStatusoptions} />
              </div>
              <button onClick={() => navigate("/user")} className={styles.reviewButton} type="button">
                بازبینی اطلاعات
              </button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return <div className={styles.page}>{userStatus === "loading" ? <Loader /> : renderContent()}</div>;
};

export default Status;
